const { getProducts, getProgram } = require('../master-data')
const { listBatches: getBatches } = require('./../../../batch/api/batch-list')
const { getAllocatedStock } = require('../read/get-allocated-stock')
const tools = require('../../tools')
const createBulkSnapshots = require('../../../shipment/shipment-bulk-create-snapshots')
const get = require('lodash/get')

// Creating warehouse suborders creates snapshots that are suborders,
// moving to accepted use the same suborder ID as the warehouse suborder
// but still create a new snapshot doc for the REST API users to edit.
exports.acceptOrders = async function (state, {
  snapshots,
  programId,
  dryRun,
  noFunderSpecificLedger = false,
  date = new Date().toJSON(),
  api
}) {
  if (!snapshots.length) {
    return {
      acceptedSnapshotsCreated: 0,
      snapshots: [],
      shipmentSnapshots: []
    }
  }

  const [productsList, batchesList, stockResponse, program] = await Promise.all([
    getProducts(state, programId),
    getBatches(state),
    getAllocatedStock(state, {programId, date, locationId: snapshots[0].supplierId, includeLedger: true, noFunderSpecificLedger}),
    getProgram(state, programId)
  ])
  const {ledgerSDPUnits, funderId} = stockResponse

  // Drop batches already expired at `date` before handing them to tools.acceptOrders.
  // Mirrors the filter inside suggestBatches — cheap here, keeps the batchesById map that
  // tools.acceptOrders holds in memory for the whole sync pass much smaller.
  const relevantBatches = batchesList.filter(batch => !batch.expiry || batch.expiry > date)

  // `managedOrders` on the program doc is the single source of truth for the
  // self-ordering behavior set:
  //  When set to false we use the facility self-ordering flow. Exact SKUs only, quantities
  //  entered in issue units, and the
  //  accepted snapshot ships as a single shipment.
  const managedOrders = get(program, 'managedOrders', true)
  const warehouseOrdersUseIssueUnits = !managedOrders
  const noAcceptedSnapshotSplit = !managedOrders

  const acceptedSnapshots = tools.acceptOrders({
    snapshots, user: state.user, ledger: ledgerSDPUnits, productsList, batchesList: relevantBatches, date, warehouseOrdersUseIssueUnits, noAcceptedSnapshotSplit, managedOrders
  })

  const rawShipmentSnapshots = tools.createShipmentSnapshots({acceptedSnapshots, funderId, productsList})
    .map(snapshot => ({...snapshot, removePaymentType: true}))

  const shipmentSnapshots = api ? await api.shipment.decorateShipmentSnapshotsWithResolvedPrices(rawShipmentSnapshots) : rawShipmentSnapshots

  if (dryRun) {
    return {
      acceptedSnapshotsCreated: acceptedSnapshots.length,
      snapshots: acceptedSnapshots,
      shipmentSnapshots
    }
  }

  await state.dal.order.bulkDocs(state, acceptedSnapshots)
  const shipments = await createBulkSnapshots(state, shipmentSnapshots)

  // TODO: this is a temporary response, see note in ordersFromSnapshotUpdates
  return {
    acceptedSnapshotsCreated: acceptedSnapshots.length,
    snapshots: acceptedSnapshots,
    shipments
  }
}
